import axios from 'axios';

// dsf
const ibospirit = axios.create({
  baseURL: 'https://backend.ibospirit.com/api/beta'
  // baseURL: 'http://ibospirit.loc.192.168.1.5.nip.io/api/beta'
});
export default ibospirit;
